<!-- 自定义 MessageBox 组件 -->
<template>
  <div class="danger-ip-dialog" v-show="isShowMessageBox">
    <div class="danger-ip-dialog-con">
      <div class="danger-ip-body">
          <div class="danger-ip-icon">

          </div>
          <div class="dialog-content">
            This content is not  available in your location.
          </div>
        </div>
    </div>
  </div>
</template>
 
<script>
export default {
  props: {
    title: {
      type: String,
      default: "标题",
    },
    content: {
      type: String,
      default: "这是弹框内容",
    },
    link: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },
  computed: {},
  data() {
    return {
      isShowMessageBox: true,
    };
  },
  methods: {
    // 确定,将promise断定为resolve状态
    confirm: function () {
      this.isShowMessageBox = false;
      // this.remove();
    },
    // 取消,将promise断定为reject状态
    cancel: function () {
      this.isShowMessageBox = false;
      // this.remove();
    },
    // 弹出messageBox,并创建promise对象
    showMsgBox: function () {
      var _this = this;
      _this.isShowMessageBox = true;
      var timer = null;
      timer = setTimeout(function(){
        console.log(213);
        _this.isShowMessageBox = false;
        clearTimeout(timer);
      },3000)
      
    },
    remove: function () {
      setTimeout(() => {
        this.destroy();
      }, 300);
    },
    destroy: function () {
      this.$destroy();
      document.body.removeChild(this.$el);
    },
  },
  created() {
    
  },
  mounted() {
    
  },
};
</script>
 
<style scoped lang="scss">
.danger-ip-dialog {
  position: relative;
  .danger-ip-dialog-con {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
    width: 400px;
    z-index: 10000;
    background-color: #fff;
    border-radius: 5px;
    box-shadow: 0px 0px 15px 0px rgba(0, 0, 0, 0.5);
    .danger-ip-body{
        padding: 18px 38px 14px;
        .danger-ip-icon{
          width: 34px;
          height: 32px;
          margin: 0 auto;
          background: url('../../../../static/img/danger-ip-icon.png') no-repeat;
          background-size: 100% 100%;
        }
        .dialog-content{
          margin-top: 13px;
          font: 400 16px/24px HelveticaLTPro-Roman;
          color: #333;
        }
      }
  }
}

@media screen and (max-width: 1560px) and (min-width: 1261px) {
  .danger-ip-dialog {
    
  }
}

@media screen and (max-width: 1260px) and (min-width: 769px) {
  .danger-ip-dialog {
    
  }
}
@media screen and (max-width: 768px) {
  .danger-ip-dialog {
    .danger-ip-dialog-con {
      width: 23rem;
      .danger-ip-body{
          padding: 1rem 1.42rem .85rem;
          .danger-ip-icon{
            width: 2.55rem;
            height: 2.4rem;
            margin: 0 auto;
            background: url('../../../../static/img/danger-ip-icon.png') no-repeat;
            background-size: 100% 100%;
          }
          .dialog-content{
            margin-top: 1rem;
            font: 400 1rem/1.33rem HelveticaLTPro-Roman;
            color: #333;
          }
        }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/common/danger-ip-dialog/index.vue